// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_Card = require("./BrowserComponents_Card.bs.js");
var BrowserComponents_Icon = require("./BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("./BrowserComponents_Text.bs.js");
var BrowserComponents_Spacer = require("./BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("./BrowserComponents_FlexRow.bs.js");

var _map = {"button":"button","submit":"submit","reset":"reset"};

function buttonTypeToJs(param) {
  return param;
}

function buttonTypeFromJs(param) {
  return _map[param];
}

function button(disabled) {
  return Curry._1(BrowserStyle.style, BrowserStyle.inheritFont({
                  hd: BrowserStyle.backgroundColor(/* Transparent */2),
                  tl: {
                    hd: BrowserStyle.borderWidth(BrowserStyle.zero),
                    tl: {
                      hd: BrowserStyle.color(/* CurrentColor */1),
                      tl: {
                        hd: BrowserStyle.important(BrowserStyle.cursor(disabled ? "notAllowed" : "pointer")),
                        tl: {
                          hd: BrowserStyle.margin(BrowserStyle.zero),
                          tl: {
                            hd: BrowserStyle.outlineStyle(BrowserStyle.none),
                            tl: {
                              hd: BrowserStyle.padding(BrowserStyle.zero),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }));
}

var Styles = {
  button: button
};

var make = React.forwardRef(function (Props, ref_) {
      var children = Props.children;
      var className = Props.className;
      var disabledOpt = Props.disabled;
      var onBlurOpt = Props.onBlur;
      var onClick = Props.onClick;
      var onDoubleClick = Props.onDoubleClick;
      var onFocusOpt = Props.onFocus;
      var onMouseEnter = Props.onMouseEnter;
      var onMouseLeave = Props.onMouseLeave;
      var tabIndex = Props.tabIndex;
      var testId = Props.testId;
      var type_Opt = Props.type_;
      var disabled = disabledOpt !== undefined ? disabledOpt : false;
      var onBlur = onBlurOpt !== undefined ? onBlurOpt : (function (param) {
            return Relude_Globals.$great$great((function (prim) {
                          
                        }), Relude_IO.pure, param);
          });
      var onFocus = onFocusOpt !== undefined ? onFocusOpt : (function (param) {
            return Relude_Globals.$great$great((function (prim) {
                          
                        }), Relude_IO.pure, param);
          });
      var type_ = type_Opt !== undefined ? type_Opt : "button";
      var partial_arg = Relude_Option.getOrElse((function (param) {
              return Relude_Globals.$great$great((function (prim) {
                            
                          }), Relude_IO.pure, param);
            }), onClick);
      var partial_arg$1 = Relude_Option.getOrElse((function (param) {
              return Relude_Globals.$great$great((function (prim) {
                            
                          }), Relude_IO.pure, param);
            }), onDoubleClick);
      var tmp = {
        className: BrowserStyle.Utils.extendBaseStyle(button(disabled), className),
        disabled: disabled,
        type: type_,
        onFocus: (function (param) {
            return Relude_Globals.$great$great(onFocus, IOUtils.unsafeRunHandledAsync, param);
          }),
        onBlur: (function (param) {
            return Relude_Globals.$great$great(onBlur, IOUtils.unsafeRunHandledAsync, param);
          }),
        onClick: (function (param) {
            return Relude_Globals.$great$great(partial_arg, IOUtils.unsafeRunHandledAsync, param);
          }),
        onDoubleClick: (function (param) {
            return Relude_Globals.$great$great(partial_arg$1, IOUtils.unsafeRunHandledAsync, param);
          })
      };
      var tmp$1 = Relude_Option.map((function (prim) {
              return prim;
            }), (ref_ == null) ? undefined : Caml_option.some(ref_));
      if (tmp$1 !== undefined) {
        tmp.ref = Caml_option.valFromOption(tmp$1);
      }
      var tmp$2 = Relude_Option.map((function (index) {
              if (index) {
                return index._0;
              } else {
                return -1;
              }
            }), tabIndex);
      if (tmp$2 !== undefined) {
        tmp.tabIndex = Caml_option.valFromOption(tmp$2);
      }
      var tmp$3 = Relude_Option.map((function (fn, param) {
              return IOUtils.unsafeRunHandledAsync(fn);
            }), onMouseEnter);
      if (tmp$3 !== undefined) {
        tmp.onMouseEnter = Caml_option.valFromOption(tmp$3);
      }
      var tmp$4 = Relude_Option.map((function (fn, param) {
              return IOUtils.unsafeRunHandledAsync(fn);
            }), onMouseLeave);
      if (tmp$4 !== undefined) {
        tmp.onMouseLeave = Caml_option.valFromOption(tmp$4);
      }
      var tmp$5 = {
        children: React.createElement("button", tmp, children)
      };
      if (testId !== undefined) {
        tmp$5.id = Caml_option.valFromOption(testId);
      }
      return React.createElement(ReactUtils.WithTestId.make, tmp$5);
    });

var Base = {
  Styles: Styles,
  make: make
};

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor(/* Transparent */2),
      tl: /* [] */0
    });

var Styles$1 = {
  container: container
};

function BrowserComponents_Button$Icon(Props) {
  var className = Props.className;
  var disabled = Props.disabled;
  var labelLeft = Props.labelLeft;
  var labelRight = Props.labelRight;
  var labelClassName = Props.labelClassName;
  var icon = Props.icon;
  var iconColor = Props.iconColor;
  var notificationDotColor = Props.notificationDotColor;
  var onBlur = Props.onBlur;
  var onFocus = Props.onFocus;
  var onClick = Props.onClick;
  var size = Props.size;
  var testId = Props.testId;
  var tmp = {
    children: null,
    className: BrowserStyle.Utils.extendBaseStyle(container, className)
  };
  if (disabled !== undefined) {
    tmp.disabled = Caml_option.valFromOption(disabled);
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  if (onFocus !== undefined) {
    tmp.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (testId !== undefined) {
    tmp.testId = Caml_option.valFromOption(testId);
  }
  var tmp$1 = {
    icon: icon
  };
  if (iconColor !== undefined) {
    tmp$1.color = Caml_option.valFromOption(iconColor);
  }
  if (notificationDotColor !== undefined) {
    tmp$1.notificationDotColor = Caml_option.valFromOption(notificationDotColor);
  }
  if (size !== undefined) {
    tmp$1.size = Caml_option.valFromOption(size);
  }
  return React.createElement(make, tmp, Relude_Option.fold(null, (function (labelLeft) {
                    var tmp = {
                      children: labelLeft
                    };
                    if (labelClassName !== undefined) {
                      tmp.className = Caml_option.valFromOption(labelClassName);
                    }
                    return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Text.make, tmp), React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Small */3
                                  }));
                  }), labelLeft), React.createElement(BrowserComponents_Icon.make, tmp$1), Relude_Option.fold(null, (function (labelRight) {
                    var tmp = {
                      children: labelRight
                    };
                    if (labelClassName !== undefined) {
                      tmp.className = Caml_option.valFromOption(labelClassName);
                    }
                    return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Small */3
                                  }), React.createElement(BrowserComponents_Text.make, tmp));
                  }), labelRight));
}

var Icon = {
  Styles: Styles$1,
  make: BrowserComponents_Button$Icon
};

var container$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display("flex"),
      tl: {
        hd: BrowserStyle.alignItems(BrowserStyle.stretch),
        tl: /* [] */0
      }
    });

function card(isSelected) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.alignItems(BrowserStyle.center),
              tl: {
                hd: BrowserStyle.backgroundColor(isSelected ? ({
                          TAG: /* Teal */6,
                          _0: /* Lightest */4
                        }) : ({
                          TAG: /* White */7,
                          _0: /* Light */2
                        })),
                tl: {
                  hd: BrowserStyle.borderColor(isSelected ? ({
                            TAG: /* Teal */6,
                            _0: /* Medium */2
                          }) : ({
                            TAG: /* Grey */2,
                            _0: /* Light */3
                          })),
                  tl: {
                    hd: BrowserStyle.flex({
                          NAME: "num",
                          VAL: 1.0
                        }),
                    tl: {
                      hd: BrowserStyle.justifyContent(BrowserStyle.center),
                      tl: {
                        hd: BrowserStyle.mobileMedia({
                              hd: BrowserStyle.flex({
                                    NAME: "num",
                                    VAL: 1.0
                                  }),
                              tl: /* [] */0
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            });
}

var Styles$2 = {
  container: container$1,
  card: card
};

function BrowserComponents_Button$Selector(Props) {
  var className = Props.className;
  var children = Props.children;
  var containerClassName = Props.containerClassName;
  var disabled = Props.disabled;
  var isSelected = Props.isSelected;
  var onClick = Props.onClick;
  var onMouseEnter = Props.onMouseEnter;
  var onMouseLeave = Props.onMouseLeave;
  var testId = Props.testId;
  var tmp = {
    children: React.createElement(BrowserComponents_Card.make, {
          className: BrowserStyle.Utils.extendBaseStyle(card(isSelected), containerClassName),
          children: children
        }),
    className: BrowserStyle.Utils.extendBaseStyle(container$1, className),
    onClick: onClick
  };
  if (disabled !== undefined) {
    tmp.disabled = Caml_option.valFromOption(disabled);
  }
  if (onMouseEnter !== undefined) {
    tmp.onMouseEnter = Caml_option.valFromOption(onMouseEnter);
  }
  if (onMouseLeave !== undefined) {
    tmp.onMouseLeave = Caml_option.valFromOption(onMouseLeave);
  }
  if (testId !== undefined) {
    tmp.testId = Caml_option.valFromOption(testId);
  }
  return React.createElement(make, tmp);
}

var Selector = {
  Styles: Styles$2,
  make: BrowserComponents_Button$Selector
};

function button$1(actionPriority, styleType, theme) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.backgroundColor(BrowserStyle.Button.toBackgroundColor(actionPriority, theme, styleType)),
              tl: {
                hd: BrowserStyle.border(BrowserStyle.Button.getBorderWidth(actionPriority), BrowserStyle.solid, BrowserStyle.Button.toBorderColor(actionPriority, theme, styleType)),
                tl: {
                  hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.5)),
                  tl: {
                    hd: BrowserStyle.boxSizing(BrowserStyle.borderBox),
                    tl: /* [] */0
                  }
                }
              }
            });
}

function container$2(size) {
  var tmp;
  switch (size) {
    case /* Small */0 :
        tmp = 0.5;
        break;
    case /* Medium */1 :
        tmp = 0.75;
        break;
    case /* Large */2 :
        tmp = 0.875;
        break;
    
  }
  var tmp$1;
  switch (size) {
    case /* Small */0 :
        tmp$1 = 0.75;
        break;
    case /* Medium */1 :
        tmp$1 = 1.0;
        break;
    case /* Large */2 :
        tmp$1 = 1.25;
        break;
    
  }
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.alignItems(BrowserStyle.center),
              tl: {
                hd: BrowserStyle.padding2(BrowserStyle.rem(tmp), BrowserStyle.rem(tmp$1)),
                tl: /* [] */0
              }
            });
}

function title(actionPriority, size, styleType, theme) {
  var arg = BrowserStyle.Button.sizeToFontSize(size);
  var arg$1 = function (param) {
    return BrowserStyle.withFont(param, /* Quicksand */0, arg, /* Bold */2);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined), {
                  hd: BrowserStyle.color(BrowserStyle.Button.toTextColor(actionPriority, theme, styleType)),
                  tl: {
                    hd: BrowserStyle.flex({
                          NAME: "num",
                          VAL: 1.0
                        }),
                    tl: {
                      hd: BrowserStyle.textAlign("center"),
                      tl: /* [] */0
                    }
                  }
                }));
}

var iconLeft = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.marginRight(BrowserStyle.Spacing.small),
      tl: /* [] */0
    });

var iconRight = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.marginLeft(BrowserStyle.Spacing.small),
      tl: /* [] */0
    });

var Styles$3 = {
  button: button$1,
  container: container$2,
  title: title,
  iconLeft: iconLeft,
  iconRight: iconRight
};

function BrowserComponents_Button(Props) {
  var actionPriority = Props.actionPriority;
  var className = Props.className;
  var contentClassName = Props.contentClassName;
  var disabledOpt = Props.disabled;
  var iconLeft$1 = Props.iconLeft;
  var iconRight$1 = Props.iconRight;
  var onClick = Props.onClick;
  var sizeOpt = Props.size;
  var tabIndex = Props.tabIndex;
  var testId = Props.testId;
  var themeOpt = Props.theme;
  var title$1 = Props.title;
  var type_ = Props.type_;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var size = sizeOpt !== undefined ? sizeOpt : /* Medium */1;
  var theme = themeOpt !== undefined ? themeOpt : /* LightBackground */0;
  var styleType = disabled ? /* Disabled */0 : /* Enabled */({
        _0: /* Blurred */0,
        _1: /* NoInteraction */0
      });
  var bufferEmptySides = Relude_Option.isSome(iconLeft$1) || Relude_Option.isSome(iconRight$1);
  var tmp = {
    children: React.createElement(BrowserComponents_FlexRow.make, {
          className: BrowserStyle.Utils.extendBaseStyle(container$2(size), contentClassName),
          children: null
        }, Relude_Option.fold(bufferEmptySides ? React.createElement("div", {
                    className: iconLeft
                  }) : null, (function (icon) {
                return React.createElement(BrowserComponents_Icon.make, {
                            className: iconLeft,
                            color: BrowserStyle.Button.toTextColor(actionPriority, theme, styleType),
                            icon: {
                              TAG: /* Small */1,
                              _0: icon
                            }
                          });
              }), iconLeft$1), React.createElement(BrowserComponents_Text.make, {
              className: title(actionPriority, size, styleType, theme),
              children: title$1
            }), Relude_Option.fold(bufferEmptySides ? React.createElement("div", {
                    className: iconRight
                  }) : null, (function (icon) {
                return React.createElement(BrowserComponents_Icon.make, {
                            color: BrowserStyle.Button.toTextColor(actionPriority, theme, styleType),
                            icon: {
                              TAG: /* Small */1,
                              _0: icon
                            },
                            size: size + 1 | 0
                          });
              }), iconRight$1)),
    className: BrowserStyle.Utils.extendBaseStyle(button$1(actionPriority, styleType, theme), className),
    disabled: disabled,
    onClick: onClick
  };
  if (tabIndex !== undefined) {
    tmp.tabIndex = Caml_option.valFromOption(tabIndex);
  }
  if (testId !== undefined) {
    tmp.testId = Caml_option.valFromOption(testId);
  }
  if (type_ !== undefined) {
    tmp.type_ = Caml_option.valFromOption(type_);
  }
  return React.createElement(make, tmp);
}

var make$1 = BrowserComponents_Button;

exports.buttonTypeToJs = buttonTypeToJs;
exports.buttonTypeFromJs = buttonTypeFromJs;
exports.Base = Base;
exports.Icon = Icon;
exports.Selector = Selector;
exports.Styles = Styles$3;
exports.make = make$1;
/* make Not a pure module */
